export default () => ({
  root: {
    width: '100%',
    maxWidth: 472,
    '@media screen and (max-width: 1100px)': {
      maxWidth: 360
    }
  },
  logo: {
    marginBottom: 28
  },
  title: {
    marginBottom: 12
  }
});